<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PaymentError',
  props: {
    value: Boolean
  },
  data: () => ({
    dialog: true
  }),
  computed: {
    ...mapGetters(['locale']),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
  }
</script>
<template>
  <div>
    <v-dialog v-model="show" width="500" persistent>
      <v-card class="mx-auto">
        <v-card-title class="background justify-left">
          <v-row align="center">
            <v-icon x-large left color="error">mdi-alert</v-icon>
            <h1 class="headline secondary--text text--primary-2 pl-2">
              {{ $t('component.upload.paymentError.header') }}
            </h1></v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5 pb-1">
          <v-list-item>
            <v-list-item-content>
              <main class="content">
                <v-list-item-subtitle
                  v-html="$t('component.upload.paymentError.content')"
                ></v-list-item-subtitle>
                <v-list-item-subtitle class="pt-4">{{
                    $t('component.upload.paymentError.iabSignature')
                  }}</v-list-item-subtitle>
              </main>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            :to="{
              name: 'orders',
              params: { locale: locale }
            }"
            color="primary"
          >{{ $t('button.back.to.payment').toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style lang="scss">
.background {
  background-color: rgb(105, 115, 122, 0.2);
}

.content {
  font-size: 16px;
  padding: 4%;
}
</style>
